import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "16",
  viewBox: "0 0 15 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1441_18233)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.6298 11.0583V12.9125C13.6305 13.0846 13.5953 13.255 13.5263 13.4127C13.4574 13.5704 13.3562 13.712 13.2294 13.8284C13.1025 13.9447 12.9528 14.0333 12.7897 14.0885C12.6267 14.1436 12.4539 14.1641 12.2825 14.1486C10.3806 13.942 8.55375 13.2921 6.94866 12.2512C5.45534 11.3023 4.18926 10.0362 3.24033 8.54287C2.19581 6.93049 1.54578 5.09474 1.34291 3.18433C1.32746 3.01342 1.34777 2.84116 1.40255 2.67853C1.45733 2.5159 1.54536 2.36645 1.66106 2.23971C1.77676 2.11297 1.91758 2.0117 2.07455 1.94237C2.23153 1.87303 2.40123 1.83714 2.57284 1.83697H4.427C4.72695 1.83402 5.01773 1.94024 5.24516 2.13582C5.47258 2.33141 5.62113 2.60302 5.66311 2.90003C5.74137 3.4934 5.8865 4.07602 6.09575 4.63676C6.1789 4.85798 6.1969 5.09839 6.14761 5.32953C6.09831 5.56066 5.98379 5.77281 5.81762 5.94086L5.03269 6.72578C5.91253 8.27311 7.19369 9.55428 8.74102 10.4341L9.52595 9.64918C9.69399 9.48301 9.90615 9.36849 10.1373 9.3192C10.3684 9.26991 10.6088 9.2879 10.83 9.37106C11.3908 9.5803 11.9734 9.72544 12.5668 9.8037C12.867 9.84605 13.1412 9.99728 13.3372 10.2286C13.5332 10.4599 13.6374 10.7552 13.6298 11.0583Z",
    stroke: "#2B3951",
    "stroke-width": "1.23611",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1441_18233" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "14.8333",
      height: "14.8333",
      fill: "white",
      transform: "translate(0.0332031 0.600586)"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };